import React from "react";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Col, Row, Form } from "react-bootstrap";
import styles from "../../layout/Auth/Auth.module.scss";
import { toast } from "react-toastify";
import { FORGET_PASSWORD } from "../../services/ApiCalls";

const schema = z.object({
  email: z
    .string()
    .min(1, { message: "Email is required" })
    .email("Invalid email address"),
});
const ForgetPassword = ({ setEmail, setIsOtpSended }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  });
  const onSubmit = async (data) => {
    try {
      const res = await FORGET_PASSWORD(data);

      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        setIsOtpSended(true);
        setEmail(data.email);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  return (
    <div className="w-100 inner">
      <div className="top py-2">
        <h4 className="m-0 fw-sbold">Forgot Password</h4>
      </div>
      <Form className={`${styles.form}`} onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col lg="12" className="my-2">
            <input
              type="email"
              className={`${styles.formControl} form-control bg-white`}
              placeholder="Enter Email ID"
              {...register("email")}
            />
            {
              <p className="errorColor">
                {errors?.email && errors.email?.message}
              </p>
            }
          </Col>
          <Col lg="8" className="my-2">
            <div className={`${styles.btnWrpper} btnWrpper`}>
              <Button
                type="submit"
                className="d-flex align-items-center justify-content-center w-100 commonBtn"
              >
                Submit
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ForgetPassword;
